/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ChanceTypeList = {
    type: 'array',
    contains: {
        type: 'ChanceType',
    },
} as const;
